import { render } from "./PetInfo.vue?vue&type=template&id=4c1bbc1a&scoped=true"
import script from "./PetInfo.vue?vue&type=script&lang=js"
export * from "./PetInfo.vue?vue&type=script&lang=js"

import "./PetInfo.vue?vue&type=style&index=0&id=4c1bbc1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1bbc1a"]])

export default __exports__